module.exports = __webpack_public_path__ + "static/media/bernes.f57bfc31.wav";